import React, { useState, useEffect } from 'react';
import { TitleComponent, CardComponent, TableComponent, ButtonGenerateComponent, ButtonActionComponent, SelectComponent, SelectComponentMulti } from '../../../components/pages/index';
import { api, apiConfig } from '../../../util/api';
import { useGetApiWs, useChangeDocTitle } from '../../../hooks/index';


const SamplesProv = (props) => {
    useChangeDocTitle('Reportes | Auditoría | Analisis');
    const urlCustomer = useGetApiWs('admin', 'entity', 'company-get');
    const urlCustonerInfo = useGetApiWs('admin', 'entity', 'customer-get');
    const urlFilter = useGetApiWs('admin', 'entity', 'analysis-samples-prov-get');

    const [customers, setCustomers] = useState([]);
    const [category, setCategory] = useState([]);

    const [attributes, setAttributes] = useState([]);
    const [cities, setCities] = useState([]);
    const [channels, setChannels] = useState([]);
    const [measurement, setMeasurement] = useState([]);
    const [defattributes, setDefAttributes] = useState([]);
    const [defcities, setDefCities] = useState([]);
    const [defchannels, setDefChannels] = useState([]);
    const [defMeasurements, setDefMeasurements] = useState([]);
    const [measurementIsDisabled, setMeasuremetIsDisabled] = useState(false);

    const [lbCustomer, setLbCustomer] = useState(null);
    const [lbCategory, setLbCategory] = useState(null);
    const [lbAttributes, setLbAttributes] = useState(null);
    const [lbCities, setLbCities] = useState(null);
    const [lbChannels, setLbChannels] = useState(null);
    const [lbValores, setLbValores] = useState(null);
    const [lbMeasurement, setLbMeasurement] = useState(null);

    const [customerIsLoading, setCustomerIsLoading] = useState(true);
    const [categoryIsLoading, setCategoryIsLoading] = useState(true);
    const [attributesIsLoading, setAttributesIsLoading] = useState(true);
    const [citiesIsLoading, setCitiesIsLoading] = useState(true);
    const [channelsIsDisabled, setChannelsIsDisabled] = useState(false);
    const [channelsIsLoading, setChannelsIsLoading] = useState(true);
    const [measurementLoading, setMeasurementIsLoading] = useState(true);

    const [tbHeadings, setTbDataHeadings] = useState([]);
    const [tbData, setTbData] = useState([]);
    const [tbColumns, setTbColumns] = useState([]);
    const [tbPending, setTbPending] = useState(true);

    const [btnExports, setBtnExports] = useState(false);

    const [Disabled, setDisabled] = useState();

    const wbname = 'Samples'

    const fetchCustomers = async () => {
        const customers = await api().post(urlCustomer, { company_type_code: 'CM-CUST' }, apiConfig());
        var options = customers.data.response.map((obj) => {
            var rObj = {};
            rObj['value'] = obj.company_id;
            rObj['label'] = obj.description;
            return rObj;
        });
        setCustomers(options);
        setCustomerIsLoading(false);
        CustomerChange({ 'value': 3, 'label': 'ALICORP' })
    }

    const fetchCategory = async (customer_id) => {
        const ob = {};
        ob['customer_id'] = customer_id;
        ob['study_id'] = 17;
        ob['type_info'] = 'categories';
        if (props.test !== null || props.test !== undefined) {
            ob['is_test'] = props.test;
        } else {
            ob['is_test'] = 0;
        }
        const cWorkOrders = await api().post(urlCustonerInfo, ob, apiConfig());
        if (cWorkOrders.status === 200 && cWorkOrders.data.status === 'success') {
            var options = cWorkOrders.data.response.map(obj => {
                var rObj = {};
                rObj['value'] = obj.category_id;
                rObj['label'] = obj.category_name;
                return rObj;
            })
            setCategory(options);
        }
        setCategoryIsLoading(false);
    }

    const fetchChannels = async (category_id, customer_id) => {
        const ob = {};
        ob['customer_id'] = customer_id;
        ob['category_id'] = category_id;
        ob['study_id'] = 17;
        ob['type_info'] = 'channels';
        if (props.test !== null || props.test !== undefined) {
            ob['is_test'] = props.test;
        } else {
            ob['is_test'] = 0;
        }
        const channels = await api().post(urlCustonerInfo, ob, apiConfig());
        var options = channels.data.response.map((obj) => {
            var rObj = {};
            rObj['value'] = obj.channel_id;
            rObj['label'] = obj.name;
            return rObj;
        });
        setChannels(options);
        setChannelsIsLoading(false);
    }
    const fetchMeasurement = async (category_id, customer_id) => {
        const ob = {};
        ob['customer_id'] = customer_id;
        ob['category_id'] = category_id;
        ob['study_id'] = 17;
        ob['type_info'] = 'measurements';
        if (props.test !== null || props.test !== undefined) {
            ob['is_test'] = 1;
        } else {
            ob['is_test'] = 1;
        }
        const measurement = await api().post(urlCustonerInfo, ob, apiConfig());
        var options = measurement.data.response.map((obj) => {
            var rObj = {};
            rObj['value'] = obj.measurement_id;
            rObj['label'] = obj.description;
            return rObj;
        });
        setMeasurement(options);
        setMeasurementIsLoading(false);
    }

    const fetchCities = async (category_id, customer_id) => {
        const ob = {};
        ob['customer_id'] = customer_id;
        ob['category_id'] = category_id;
        ob['study_id'] = 17;
        ob['type_info'] = 'cities';
        if (props.test !== null || props.test !== undefined) {
            ob['is_test'] = props.test;
        } else {
            ob['is_test'] = 0;
        }
        const customers = await api().post(urlCustonerInfo, ob, apiConfig());
        var options = customers.data.response.map((obj) => {
            var rObj = {};
            rObj['value'] = obj.city_id;
            rObj['label'] = obj.name;
            return rObj;
        });
        setCities(options);
        setCitiesIsLoading(false);
    }

    const CustomerChange = async vals => {
        setLbCustomer(vals);
        if (vals === null) {
            setCategory([]);
            setLbCategory(null);
        } else {
            setCategory([]);
            setLbCategory(null);
            fetchCategory(vals.value);
        }
    }

    const CategoryChange = async vals => {
        ClearForm();
        setLbCategory(vals);

        if (vals !== null) {
            fetchCities(vals.value, lbCustomer.value);
            fetchChannels(vals.value, lbCustomer.value);
            fetchMeasurement(vals.value, lbCustomer.value);
        }
    }

    const CityChange = async vals => {
        setLbCities(vals);

        const arrCities = vals.map((obj) => {
            return obj.label
        })

        if (arrCities.includes('LIMA') & arrCities.length === 1) {
            setChannelsIsDisabled(false);
        } else {
            setDefChannels(channels);
            setLbChannels(channels)
            setChannelsIsDisabled(true);
        }

        if (arrCities.length === 0) {
            setChannelsIsDisabled(false);
        }

    }

    const MeasurementChange = async vals => {
        setLbMeasurement(vals);
    }

    const Filter = () => {
        setBtnExports(false);
        fetchFilters();
    }

    const fetchFilters = async () => {
        if (lbCategory != null && lbChannels != null && lbAttributes != null && lbCities != null && lbMeasurement != null) {
            setTbPending(true);
            const ob = {};
            ob['customer_id'] = lbCustomer.value;
            ob['category_id'] = lbCategory.label + '|' + lbCategory.value + '|';

            //const fea = lbAttributes.map((obj) => { return obj.label + '|' + obj.value + '|'; });
            const chan = lbChannels.map((obj) => { return obj.label + '|' + obj.value + '|'; });
            const cit = lbCities.map((obj) => { return obj.label + '|' + obj.value + '|'; });
            const mer = lbMeasurement.map((obj) => { return obj.label + '|' + obj.value + '|'; });

            ob['features'] = '|1|'
            ob['cities'] = cit.join(',');
            ob['channels'] = chan.join(',');
            ob['measurements'] = mer.join(',');

            var headers = [];
            const res = await api().post(urlFilter, ob, apiConfig());
            if (res.data.status === 'success') {
                let colum = [];
                if (res.data.response.length > 0) {
                    const head = res.data.response[0]
                    headers = Object.keys(head)
                    const headersP = headers.slice(-2)
                    for (var h in headers) {
                        colum.push({
                            name: headers[h], selector: headers[h], sortable: true
                        })
                    }

                    setBtnExports(true);
                    setTbColumns(colum);
                    setTbData(res.data.response);
                    setTbPending(false);
                } else {
                    setBtnExports(false);
                    setTbColumns([]);
                    setTbData([]);
                    setTbPending(false);
                }
            }
        } else {
            return null;
        }
    }

    const ClearForm = () => {
        setAttributes([]);
        setCities([]);
        setChannels([]);
        setMeasurement([]);

        setLbMeasurement([]);
        setLbAttributes([]);
        setLbCities([]);
        setLbChannels([]);

        setDefAttributes([]);
        setDefCities([]);
        setDefChannels([]);
        setDefMeasurements([]);

        setAttributesIsLoading(false);
        setCitiesIsLoading(false);
        setChannelsIsLoading(false);
        setChannelsIsDisabled(false);
        setMeasurementIsLoading(false);
        setBtnExports(false);
        setTbData([]);
        setTbPending(false);
    }

    useEffect(() => {
        fetchCustomers();
        setCategory([]);
        setLbCategory(null);
        setLbValores(null);
        setCategoryIsLoading(false);
        ClearForm();
    }, []);


    return (
        <div>
            <TitleComponent title="MUESTRAS PROVINCIAS" />
            <div className="pt-3">
                <CardComponent header={null} footer={null}>
                    <div className="bg-white p-2">
                        <div className="grid md:grid-cols-4 lg:grid-cols-4 items-center gap-4 z-10">
                            <SelectComponent onChange={CustomerChange} options={customers} value={lbCustomer} isLoading={customerIsLoading} label="Clientes" isDisabled={Disabled} />
                            <SelectComponent onChange={CategoryChange} options={category} value={lbCategory} isLoading={categoryIsLoading} label="Categoría" />
                            <SelectComponentMulti onChange={CityChange} defaultValue={defcities} options={cities} isLoading={citiesIsLoading} value={lbCities} label="Ciudades" />
                            <SelectComponentMulti onChange={(vals) => { setLbChannels(vals) }} defaultValue={defchannels} options={channels} value={lbChannels} isDisabled={channelsIsDisabled} isLoading={channelsIsLoading} label="Canales" />
                            <SelectComponentMulti onChange={(vals) => { MeasurementChange(vals) }} defaultValue={defMeasurements} options={measurement} value={lbMeasurement} isLoading={measurementLoading} isDisabled={measurementIsDisabled} isOptionDisabled={() => lbMeasurement.length >= 3} label="Medición" />
                        </div>
                        <div className="bg-white p-2 justify-items-end grid">
                            <div className="space-x-4">
                                <ButtonActionComponent name="GENERAR REPORTE" onClick={Filter} />
                                {/* {(btnExports) ? <ButtonGenerateComponent name="EXPORTAR EXCEL" onClick={props.createDataExcel} tbColumns={tbColumns} tbData={tbData} lbCustomer={lbCustomer} lbCategory={lbCategory} lbAttributes={lbAttributes} lbCities={lbCities} lbMeasurement={lbMeasurement} lbChannels={lbChannels} wbname={wbname} /> : null}
                             */}</div>
                        </div>
                    </div>
                </CardComponent>
            </div>
            <div className="pt-3">
                <CardComponent header={<h4 className="">MUESTRAS</h4>} footer={null}>
                    <div className="bg-white">
                        <TableComponent
                            keyField="work_order_id"
                            columns={tbColumns}
                            headItem={tbHeadings}
                            data={tbData}
                            pending={tbPending}
                            highlightOnHover={true}
                        />

                    </div>
                </CardComponent>
            </div>
        </div>
    )
}
export default SamplesProv;